var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"th-pt-24"},[_c('v-slider',{attrs:{"max":_vm.input.max || 10,"min":_vm.input.min || 0,"thumb-size":24,"thumb-label":"always"},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }